export default `<li class="search-recent__item">
    <a class="search-recent__name" href=""><%= data.term %></a>
</li>`;